import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccessibilityConstants } from './accessibility.constants';
import { AccessibleClickableElementDirective, AccessibleImagesDirective } from './directives';

@NgModule({
	imports: [CommonModule],
	declarations: [
		AccessibleClickableElementDirective,
		AccessibleImagesDirective
	],
	exports: [
		AccessibleClickableElementDirective,
		AccessibleImagesDirective
	]
})
export class AccessibilityModule {

	constructor() {
		const shouldDebugAda = window.location.href.includes(AccessibilityConstants.DEBUG_URL_PARAM + '=true');
		const shouldClearDebugAda = window.location.href.includes(AccessibilityConstants.DEBUG_URL_PARAM + '=false');
		if (shouldDebugAda) {
			localStorage.setItem(AccessibilityConstants.DEBUG_URL_PARAM, 'true');
		} else if (shouldClearDebugAda) {
			localStorage.removeItem(AccessibilityConstants.DEBUG_URL_PARAM);
		}
	}
}
